export default __webpack_public_path__ + "f27f08e4cd4aefaa0e518d5e376a4113.png";